import React from 'react'
//=======Material UI
import Grid from '@material-ui/core/Grid'
import useTheme from '@material-ui/core/styles/useTheme'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import Researcher from './researcher/researcher'
import Officer from './officer/officer'
import useCheckPermission from '../../../../../utilities/checkPermission'
import Dialog from '../../../../../control/dialog/dialog'
import Button from '../../../../../control/button/button'
import useTranslate from '../../../../../i18n/useTranslate'

import ButtonSubmittedWithdraw from '../../page/_sharedPageComponent/buttonSubmittedWithdraw/buttonSubmittedWithdraw'
import useProjectWithdrawal from './useProjectWithdrawal'
import constSubmittedStep from '../../../../../constants/submittedStep'

type ProjectWithdrawalViewProps = ReturnType<typeof useProjectWithdrawal> & ProjectWithdrawalProps
const ProjectWithdrawalView: React.FC<ProjectWithdrawalViewProps> = (props) => {
    const {
        projectMode,
        isViewMode,
        configDialog,
        projectData,
        onRefDialog,
        onCallbackSaveComplete,
        onClickBackToSearch,
    } = props
    const checkPermission = useCheckPermission()
    const isUserResearcher = checkPermission.isUserResearcher()
    const translate = useTranslate()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    const isBtnClose =
        checkPermission.isUserChairman() && projectData?.stepID === constSubmittedStep.confirmProjectWithdraw
            ? false
            : isViewMode

    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData, checkPermission.isUserAdmin())

    const renderUserRoleComponent = () => {
        if (isUserResearcher) {
            return <Researcher projectMode={projectMode} callbackSaveComplete={onCallbackSaveComplete} />
        } else {
            return <Officer projectMode={projectMode} callbackSaveComplete={onCallbackSaveComplete} />
        }
    }
    return (
        <Grid container spacing={2}>
            <Grid container item>
                {renderUserRoleComponent()}
            </Grid>
            {isBtnClose && !canUpdateDocument && (
                <Grid container item justify="space-between" spacing={2}>
                    <Grid item xs={12} sm={'auto'}>
                        <ButtonSubmittedWithdraw gridProps={{ xs: true }} fullWidth={isMobileView ? true : false} />
                    </Grid>
                    <Grid item xs={12} sm={'auto'}>
                        <Button color="primary" onClick={onClickBackToSearch} fullWidth={isMobileView ? true : false}>
                            {translate.get('BUTTON.CLOSE')}
                        </Button>
                    </Grid>
                </Grid>
            )}
            <Dialog onRef={onRefDialog} {...configDialog} />
        </Grid>
    )
}
export type ProjectWithdrawalProps = {
    projectMode: 'CREATE' | 'EDIT'
}
const ProjectWithdrawal: React.FC<ProjectWithdrawalProps> = (props) => {
    const projectWithdrawal = useProjectWithdrawal(props)
    return <ProjectWithdrawalView {...projectWithdrawal} {...props} />
}
export default ProjectWithdrawal
